/**
 * Categories the org-level default sending mailbox / default Cc recipients
 * are configured per: "orders" is sales orders, "purchase_orders" is
 * procurement POs, and "general" covers everything else. Strict semantics:
 * "general" is NOT a fallback for the specific categories.
 */
export const EMAIL_SEND_CATEGORIES = [
  "general",
  "orders",
  "purchase_orders",
  "discounts",
] as const;

export type EmailSendCategory = (typeof EMAIL_SEND_CATEGORIES)[number];

/**
 * Microsoft Graph's sendMail accepts attachments inline as base64 up to a
 * documented 3 MB ceiling; larger totals need the upload-session API, which
 * the app does not use. Shared so the compose contract, the server-side
 * budget check and the compose panel's running total agree on one number.
 */
export const GRAPH_INLINE_ATTACHMENT_MAX_BYTES = 3_000_000;

/** The one user-facing message for exceeding the inline attachment cap. */
export function inlineAttachmentLimitMessage(
  limitBytes: number = GRAPH_INLINE_ATTACHMENT_MAX_BYTES,
): string {
  const limitMb = Math.floor(limitBytes / 1_000_000);
  return `Total attachment size exceeds the email service's inline limit of ${limitMb} MB. Remove an attachment or compress the files.`;
}
